import { useEffect, useState } from 'react';
import $ from 'jquery';

const GoogleTranslate = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const widgetId = 'google_translate_element';
    let duplicateCounter = 0;

    // Custom language order
    const customOrder = ['en', 'hi', 'gu', 'ta', 'te', 'bn', 'ml', 'kn', 'pa', 'mr'];

    // Prevent duplicate widgets
    if (document.getElementById(widgetId)?.childElementCount > 0) return;

    const addScript = () => {
      if (document.getElementById('google-translate-script')) return;

      const script = document.createElement('script');
      script.id = 'google-translate-script';
      script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      script.async = true;
      document.body.appendChild(script);
    };

    // Define global init function
    if (!window.googleTranslateElementInit) {
      window.googleTranslateElementInit = () => {
        if (document.getElementById(widgetId)?.childElementCount === 0 && duplicateCounter === 0) {
          const select = $(`#${widgetId} select`);
          const selectedOption = select.find('option:selected');

          // Sort languages according to custom order
          select.html(
            select.children('option').sort((a, b) => {
              return customOrder.indexOf(a.value) - customOrder.indexOf(b.value);
            })
          );

          select.val(selectedOption.val());

          new window.google.translate.TranslateElement(
            {
              pageLanguage: 'en',
              includedLanguages: customOrder.join(','),
              layout: window.google.translate.TranslateElement.InlineLayout.VERTICAL,
            },
            widgetId
          );

          duplicateCounter++;

          // Remove unwanted header
          const translatorH1 = document.querySelector('.VIpgJd-yAWNEb-r4nke');
          if (translatorH1) {
            translatorH1.remove();
          }
        }
      };
    }

    // Handle mobile/desktop switching
    const handleResize = () => {
      if (window.innerWidth < 768 && !isMobile) {
        setIsMobile(true);
        $(`#${widgetId}`).detach().appendTo('#google_translate_element_mobile');
      } else if (window.innerWidth >= 768 && isMobile) {
        setIsMobile(false);
        $(`#${widgetId}`).detach().appendTo('.language-btn');
      }
    };

    // Initial resize and add event listener
    handleResize();
    window.addEventListener('resize', handleResize);
    addScript();

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isMobile]);

  return (
    <>
      <div id="google_translate_element" className="google-translate-widget" />
      <div id="google_translate_element_mobile" className="google-translate-mobile" />
    </>
  );
};

export default GoogleTranslate;